import { IconButton } from "@nova/component-btn"
import { FormEventHandler, useEffect, useRef, useState } from "react"

import * as Icons from "@nova/component-icons"

export const ChecklistQuestionOptionInput = ({
    initialValue,
    onCancel,
    onSubmit,
}: {
    initialValue: string
    onSubmit: (val: string) => void
    onCancel: () => void
}) => {
    const [inputValue, setInputValue] = useState(initialValue)
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        inputRef.current?.focus()
        inputRef.current?.select()
    }, [])

    const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
        e.preventDefault()
        onSubmit(inputValue)
    }

    return (
        <form onSubmit={handleSubmit} className="flex gap-1 border-b border-b-gray-700">
            <input
                ref={inputRef}
                className="bg-transparent p-0 text-gray-0 border-none focus:outline-none text-[14px]"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
            />
            <IconButton onClick={() => onSubmit(inputValue)}>
                <Icons.SmallIcon Icon={Icons.Checkmark} className="text-green-500" />
            </IconButton>
            <IconButton onClick={() => onCancel()}>
                <Icons.SmallIcon Icon={Icons.XClose} className="text-gray-400" />
            </IconButton>
        </form>
    )
}
